import BaseAPI from '@/apis/base/baseApi';
export default class CREApi extends BaseAPI {
  apiName = 'CRE';
}
